import gql from 'graphql-tag';

const DICTIONARY_ENTRIES_QUERY = gql`
    query DictionaryEntries {
        dictionaryEntries {
            id
            title
            slug
            summary
        }
    }
`;

export default DICTIONARY_ENTRIES_QUERY;
